<template>
  <div class="search-page">
    <el-card class="search-card">
      <el-input
        v-model="searchQuery"
        placeholder="请输入公司名称"
        class="search-input"
        @keyup.enter.native="performSearch"
      >
        <el-button slot="append" icon="el-icon-search" @click="performSearch">搜索</el-button>
      </el-input>
    </el-card>

    <el-card v-if="isLoading" class="loading-card">
      <el-spinner type="spinner" size="large"></el-spinner>
      <p>正在搜索,请稍候...</p>
    </el-card>

    <el-card v-if="searchResult && !isLoading" class="result-card">
      <h2>{{ searchResult.company_name }}</h2>
      <el-card class="box-card">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-descriptions title="公司信息" :column="1" border>
              <el-descriptions-item label="公司名称">{{ searchResult.company_name }}</el-descriptions-item>
              <el-descriptions-item label="联系电话">{{ searchResult.concat_phone }}</el-descriptions-item>
              <el-descriptions-item label="邮箱">
                <ul v-if="Array.isArray(searchResult.concat_email_list) && searchResult.concat_email_list.length">
                  <li v-for="(email, index) in searchResult.concat_email_list" :key="index">
                    <i class="el-icon-message"></i> {{ email }}
                  </li>
                </ul>
                <span v-else>暂无</span>
              </el-descriptions-item>
              <el-descriptions-item label="地址">{{ searchResult.concat_address }}</el-descriptions-item>
              <el-descriptions-item label="行业">{{ searchResult.industry }}</el-descriptions-item>
              <el-descriptions-item label="负责人">{{ searchResult.company_leader }}</el-descriptions-item>
              <el-descriptions-item label="网址">
                <a :href="searchResult.url" target="_blank">{{ searchResult.url }}</a>
              </el-descriptions-item>
            </el-descriptions>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>公司简介</span>
              </div>
              <p>{{ searchResult.company_introduction }}</p>
            </el-card>
          </el-col>
        </el-row>
      </el-card>
      
      <el-card class="box-card" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span>公司历史</span>
        </div>
        <p class="company-history">{{ searchResult?.company_history || '暂无' }}</p>
      </el-card>

      <el-card v-if="searchResult?.product_list && searchResult.product_list.length > 0" class="box-card" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span>产品列表</span>
        </div>
        <ul>
          <li v-for="(product, index) in searchResult.product_list" :key="index">
            {{ product }}
          </li>
        </ul>
      </el-card>

      <el-card v-if="searchResult?.company_news_list && searchResult.company_news_list.length > 0" class="box-card" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span>公司新闻</span>
        </div>
        <ul>
          <li v-for="(news, index) in searchResult.company_news_list" :key="index">
            {{ news }}
          </li>
        </ul>
      </el-card>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SearchPage',
  data() {
    return {
      searchQuery: '',
      searchResult: null,
      isLoading: false,
    };
  },
  computed: {
    formattedResult() {
      if (!this.searchResult) return '';
      try {
        return JSON.stringify(this.searchResult, null, 2);
      } catch (e) {
        return this.searchResult;
      }
    },
  },
  methods: {
    async performSearch() {
      if (!this.searchQuery.trim()) return;
      this.isLoading = true;
      try {
        const response = await axios.post('https://www.haomiaodata.com/api/company_search/', {
          query: this.searchQuery,
        }, {
          headers: {
            'Content-Type': 'application/json',
          },
          timeout: 1000000 // 增加超时时间到10秒
        });
        console.log(response.data);
        this.searchResult = response.data.data;
        // 确保 concat_email_list 是一个数组
        if (this.searchResult && !Array.isArray(this.searchResult.concat_email_list)) {
          this.searchResult.concat_email_list = this.searchResult.concat_email_list ? [this.searchResult.concat_email_list] : [];
        }
      } catch (error) {
        console.error('搜索出错:', error);
        this.$message.error('搜索失败，请稍后重试');
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.search-page {
  padding: 20px;
}

.search-card {
  margin-bottom: 20px;
}

.search-input {
  width: 100%;
}

.result-card {
  margin-top: 20px;
}

.result-content {
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: monospace;
  font-size: 14px;
  line-height: 1.5;
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
  max-height: 600px;
  overflow-y: auto;
}

.loading-card {
  text-align: center;
  padding: 20px;
}

.company-history {
  white-space: pre-wrap;
  line-height: 1.6;
}

.el-descriptions {
  margin-bottom: 20px;
}

h2, h3 {
  margin-bottom: 15px;
}

.el-icon-message {
  margin-right: 5px;
  color: #409EFF;
}
</style>